import { MarginStyleProps } from 'foundations-components/types';
import { AvatarBorderStyleProps } from '../types/SharedPropTypes';

export const getMarginProps = (
  props: Record<string, any>
): MarginStyleProps => {
  return {
    margin: props.margin,
    marginBlock: props.marginBlock,
    marginBlockEnd: props.marginBlockEnd,
    marginBlockStart: props.marginBlockStart,
    marginInline: props.marginInline,
    marginInlineEnd: props.marginInlineEnd,
    marginInlineStart: props.marginInlineStart,
  };
};

export const getBorderProps = (
  props: Record<string, any>
): AvatarBorderStyleProps => {
  return {
    borderWidth: props.borderWidth,
    borderColor: props.borderColor,
    borderStyle: props.borderStyle,
  };
};
